export const notifications = (state) => state.notifications

export const quotationNotifications = (state) => state.quotationNotifications

export const profiles = (state) => state.profiles

export const loading = (state) => state.loading

export const quotationLoading = (state) => state.quotationLoading

export const notificationCount = (state) => state.notifications.length

export const quotationNotificationCount = (state) => state.quotationNotifications.length

export const totalNotificationCount = (state) => state.notifications.length + state.quotationNotifications.length

export const hasNotifications = (state) => state.notifications.length > 0

export const hasQuotationNotifications = (state) => state.quotationNotifications.length > 0

export const hasAnyNotifications = (state) => state.notifications.length > 0 || state.quotationNotifications.length > 0

export const lastFetch = (state) => state.lastFetch

export const lastQuotationFetch = (state) => state.lastQuotationFetch

export const testMode = (state) => state.testMode

export const notificationsByType = (state) => {
  return state.notifications.reduce((acc, notification) => {
    const type = notification.type
    if (!acc[type]) {
      acc[type] = []
    }
    acc[type].push(notification)
    return acc
  }, {})
}

// Combina as notificações com cotações primeiro, depois cadastrais
export const allNotificationsSorted = (state) => {
  return [...state.quotationNotifications, ...state.notifications]
}
